import { TileColor, TileSymbol, ALL_COLORS, ALL_SYMBOLS } from './tiles';
import { ShapeId } from './shapes';

export interface DifficultyTier {
  gridSize: number;
  shapeId: ShapeId;
  colors: TileColor[];
  symbols: TileSymbol[];
}

const WORLD_SHAPES: ShapeId[] = ['square', 'diamond', 'rectangle', 'hourglass', 'heart'];

const POOL_RAMP: Array<{ colors: number; symbols: number }> = [
  { colors: 3, symbols: 4 },
  { colors: 3, symbols: 5 },
  { colors: 4, symbols: 5 },
  { colors: 4, symbols: 6 },
  { colors: 5, symbols: 6 },
];

export function getDifficultyTier(level: number): DifficultyTier {
  const zeroLevel = (level - 1) % 25;
  const worldIndex = Math.floor(zeroLevel / 5);
  const levelInWorld = zeroLevel % 5;

  const pool = POOL_RAMP[levelInWorld];

  return {
    gridSize: 7,
    shapeId: WORLD_SHAPES[worldIndex],
    colors: ALL_COLORS.slice(0, pool.colors),
    symbols: ALL_SYMBOLS.slice(0, pool.symbols),
  };
}
